module.exports = "/_next/static/images/8da613ac8451c0c95a418b31e2d9d8a5-bill-filled-package.png.webp";